import api from 'api/api'
import { toast } from 'react-toastify'

import { downloadBase64File } from 'utils'
import { FILE_TYPE } from 'constants/index'

export const GET_PURCHASES = '[PURCHASES] GET PURCHASES'
export const DOWNLOADING_PURCHASES_REPORT = "[PURCHASES] DOWNLOADING PURCHASES REPORT"
export const GET_PURCHASE = '[PURCHASES] GET PURCHASE'
export const SET_PURCHASE_RECORD_FILTERS = '[PURCHASES] SET RECORD FILTERS'
export const SET_PURCHASE_RECORD_PAGE = '[PURCHASES] SET RECORD PAGE'
export const GET_PURCHASE_CORRECTION_SUMMARY = '[PURCHASES] GET CORRECTION SUMMARY'
export const GET_PURCHASE_CORRECTION_ITEMS = '[PURCHASES] GET CORRECTION ITEMS'
export const CRUD_PURCHASE_HEADER = '[PURCHASES] CRUD PURCHASE HEADER'
export const CRUD_PURCHASE = '[PURCHASES] CRUD PURCHASE'
export const CRUD_PURCHASE_ITEM = '[PURCHASES] CRUD PURCHASE ITEM'
export const GET_PURCHASE_DIAGNOSIS = '[PURCHASES] GET DIAGNOSIS'
export const CRUD_PURCHASE_PROVIDER = '[PURCHASES] CRUD PROVIDER'
export const CRUD_PURCHASE_CREDIT_NOTE = '[PURCHASES] CRUD CREDIT NOTE'
export const CRUD_PURCHASE_FIELD = '[PURCHASES] CRUD FIELD'
export const CRUD_PURCHASE_ITEM_FIELD = '[PURCHASES] CRUD ITEM FIELD'
export const CRUD_PURCHASE_ITEM_CORRECTION = '[PURCHASES] CRUD ITEM CORRECTION'
export const GET_PURCHASE_ITEMS = '[PURCHASES] GET PURCHASE ITEMS'
export const FINISH_PURCHASE_DETAIL = '[PURCHASES] FINISH PURCHASE DETAIL'

/**
 * Falla de una correccion, distinguiendo el rechazo previsto del backend de un
 * error inesperado.
 *
 * El backend responde HTTP 200 con el codigo real en `data.status`, asi que un
 * "operación rechazada" llega por la rama de exito de axios y hay que revisarlo a
 * mano. `delBackend` permite que la accion decida como avisar: el rechazo previsto
 * se dibuja en rojo dentro del modal, y el error inesperado sale como toast.
 *
 * @param {string}  mensaje
 * @param {boolean} delBackend
 * @returns {Error}
 */
const correctionFailure = (mensaje, delBackend) => {
  const error = new Error(mensaje || '')

  error.mensaje = mensaje
  error.delBackend = delBackend

  return error
}

export function getPurchases(filters = { startDate: '', endDate: '', paymentType: '', search: '', pageSize: 10 }) {
  const request = api.get(`/purchases/registers`, { params: filters })
  return (dispatch) => {
    dispatch({ type: GET_PURCHASES, payload: { loading: true } })
    request.then((response) => {

      dispatch({ type: GET_PURCHASES, payload: { ...response.data.data } })
    }).catch((error) => {
      toast.error('Error inesperado. No se pudo obtener las compras')
      console.log(GET_PURCHASES, error)
    }).finally(() => {
      dispatch({ type: GET_PURCHASES, payload: { loading: false } })
    })
  }
}

export function downloadPurchasesReportPdf(
  {
    providerId = 0,
    startDate = '',
    endDate = '',
    paymentType = '',
    status = '',
    search = '',
  }
) {
  const request = api.get(`/compra/pdf-reporte-compras`, {
    params: {
      proveedor_id: providerId,
      fecha_inicio: startDate,
      fecha_fin: endDate,
      tipo_pago: paymentType,
      estado: status,
      busqueda: search,
    }
  })
  return (dispatch) => {
    dispatch({ type: DOWNLOADING_PURCHASES_REPORT, payload: true })
    request.then((response) => {
      downloadBase64File({
        filename: response.data.nombre,
        fileType: FILE_TYPE.PDF,
        file: response.data.archivo
      })
      toast.success('Se descargó el PDF.')
      dispatch({ type: DOWNLOADING_PURCHASES_REPORT, payload: false })
      return
    }).catch((error) => {
      dispatch({ type: DOWNLOADING_PURCHASES_REPORT, payload: false })
      toast.error('Algo salió mal. No se pudo descargar el PDF.')
      console.error(error)
    })
  }
}

export function downloadPurchasesReportExcel(
  {
    providerId = 0,
    startDate = '',
    endDate = '',
    paymentType = '',
    status = '',
    search = '',
  }
) {
  const request = api.get(`/compra/excel-reporte-compras`, {
    params: {
      proveedor_id: providerId,
      fecha_inicio: startDate,
      fecha_fin: endDate,
      tipo_pago: paymentType,
      estado: status,
      busqueda: search,
    }
  })
  return (dispatch) => {
    dispatch({ type: DOWNLOADING_PURCHASES_REPORT, payload: true })
    request.then((response) => {
      downloadBase64File({
        filename: response.data.nombre,
        fileType: FILE_TYPE.EXCEL,
        file: response.data.archivo
      })
      toast.success('Se descargó el EXCEL.')
      dispatch({ type: DOWNLOADING_PURCHASES_REPORT, payload: false })
      return
    }).catch((error) => {
      dispatch({ type: DOWNLOADING_PURCHASES_REPORT, payload: false })
      toast.error('Algo salió mal. No se pudo descargar el EXCEL.')
      console.error(error)
    })
  }
}

/** Filtros y pagina del listado. Van al store para conservarlos al navegar. */
export function setPurchaseRecordFilters(filters) {
  return { type: SET_PURCHASE_RECORD_FILTERS, payload: filters }
}

export function setPurchaseRecordPage(page) {
  return { type: SET_PURCHASE_RECORD_PAGE, payload: page }
}

/**
 * Resumen de la compra para el menu de correcciones.
 *
 * Endpoint dedicado, no se recicla getPurchase: este devuelve solo lo que el menu
 * necesita (estado, forma de pago, moneda). Traer la compra entera hacia que los
 * cuadrados se pintaran antes de conocer el estado de pago y aparecieran despues.
 */
export function getCorrectionSummary({ purchaseId }) {
  return (dispatch) => {
    dispatch({
      type: GET_PURCHASE_CORRECTION_SUMMARY,
      payload: { loading: true, data: null, items: [], credito: null },
    })

    return api
      .get(`/compra/correccion/resumen/${purchaseId}`)
      .then((response) => {
        // La cabecera viene en `data`, los items en `items` y el credito del
        // proveedor en `credito`, y se piden en la misma llamada para que la
        // pagina no muestre una tabla vacia un instante mientras llega la
        // segunda. El credito es `null` en una compra al contado.
        dispatch({
          type: GET_PURCHASE_CORRECTION_SUMMARY,
          payload: {
            loading: false,
            data: response.data.data,
            items: response.data.items,
            credito: response.data.credito,
          },
        })

        return response.data.data
      })
      .catch(() => {
        dispatch({
          type: GET_PURCHASE_CORRECTION_SUMMARY,
          payload: { loading: false, data: null, items: [], credito: null },
        })
        return null
      })
  }
}

/**
 * Items para la pantalla de correccion. Endpoint dedicado con solo los campos que
 * esa pantalla usa.
 */
export function getCorrectionItems({ purchaseId }) {
  return (dispatch) => {
    dispatch({ type: GET_PURCHASE_CORRECTION_ITEMS, payload: { loading: true, items: [] } })

    return api
      .get(`/compra/correccion/items/${purchaseId}`)
      .then((response) => {
        dispatch({
          type: GET_PURCHASE_CORRECTION_ITEMS,
          payload: { loading: false, items: response.data.data },
        })

        return response.data.data
      })
      .catch(() => {
        dispatch({ type: GET_PURCHASE_CORRECTION_ITEMS, payload: { loading: false, items: [] } })
        return []
      })
  }
}

export function clearCorrection() {
  return {
    type: GET_PURCHASE_CORRECTION_SUMMARY,
    payload: { loading: false, data: null, items: [], credito: null },
  }
}

export function getPurchase({ purchaseId }) {
  const request = api.get(
    `/compra/obtener-compra?idcompra=${purchaseId}`
  )
  return (dispatch) => {
    dispatch({ type: GET_PURCHASE, payload: { loading: true } })
    request.then((response) => {
      dispatch({
        type: GET_PURCHASE,
        payload: { loading: false, data: response.data.detalles },
      })
      setTimeout(() => {
        dispatch({
          type: GET_PURCHASE,
          payload: { loading: false, data: null },
        })
      }, 50)
    }).catch((error) => {
      dispatch({ type: GET_PURCHASE, payload: { loading: false, data: null } })
      toast.error('Error inesperado, no se pudo obtener la compra')
      console.log(error)
    })
  }
}

/**
 * Diagnostico de correccion de una compra finalizada.
 *
 * Es solo lectura: clasifica la compra en reabrir / nota_credito / bloqueado y
 * explica por que, para que el operador decida antes de intentar.
 */
export function getPurchaseDiagnosis({ purchaseId = 0 } = {}) {
  return (dispatch) => {
    dispatch({ type: GET_PURCHASE_DIAGNOSIS, payload: { loading: true } })

    return api
      .get(`/compra/diagnostico/${purchaseId}`)
      .then((response) => {
        dispatch({
          type: GET_PURCHASE_DIAGNOSIS,
          payload: { loading: false, diagnosis: response.data.data },
        })

        return response.data.data
      })
      .catch((error) => {
        dispatch({ type: GET_PURCHASE_DIAGNOSIS, payload: { loading: false } })
        toast.error(error?.response?.data?.message || 'No se pudo obtener el diagnóstico de la compra')
        return null
      })
  }
}

/**
 * Registra una nota de credito del proveedor sobre una compra finalizada.
 * Corrige el monto sin tocar el kardex ni el stock.
 */
export function savePurchaseCreditNote(form) {
  const request = api.post(`/compra/nota-credito`, form)

  return (dispatch) => {
    dispatch({ type: CRUD_PURCHASE_CREDIT_NOTE, payload: { loading: true } })

    return request
      .then((response) => {
        dispatch({
          type: CRUD_PURCHASE_CREDIT_NOTE,
          payload: { loading: false, crud: true, data: response.data.detalles },
        })

        toast.success(response.data.message || 'Nota de crédito registrada')
        return response.data
      })
      .catch((error) => {
        const mensaje = error?.response?.data?.message || 'No se pudo registrar la nota de crédito'
        dispatch({
          type: CRUD_PURCHASE_CREDIT_NOTE,
          payload: { loading: false, error: mensaje },
        })
        toast.error(mensaje)
        return Promise.reject(new Error(mensaje))
      })
  }
}

/**
 * Correcciones dirigidas sobre un item de una compra YA FINALIZADA.
 *
 * Cada una hace solo lo que su nombre dice: el precio no toca el stock, la
 * cantidad si, y cambiar de producto mueve stock de un producto a otro.
 */
export function correctPurchaseItemPrice(form) {
  return (dispatch) => dispatchCrudItem(dispatch, '/compra/corregir-precio', form, 'Precio actualizado')
}

export function correctPurchaseItemQuantity(form) {
  return (dispatch) => dispatchCrudItem(dispatch, '/compra/corregir-cantidad', form, 'Cantidad actualizada')
}

export function correctPurchaseItemProduct(form) {
  return (dispatch) => dispatchCrudItem(dispatch, '/compra/corregir-producto', form, 'Producto actualizado')
}

const dispatchCrudItem = (dispatch, url, form, successMessage) => {
  dispatch({ type: CRUD_PURCHASE_ITEM_CORRECTION, payload: { loading: true } })

  return api
    .post(url, form)
    .then((response) => {
      dispatch({ type: CRUD_PURCHASE_ITEM_CORRECTION, payload: { loading: false, crud: true } })
      toast.success(response.data.message || successMessage)
      return response.data
    })
    .catch((error) => {
      const mensaje = error?.response?.data?.message || 'No se pudo aplicar la corrección'
      dispatch({
        type: CRUD_PURCHASE_ITEM_CORRECTION,
        payload: { loading: false, error: mensaje },
      })
      toast.error(mensaje)
      // Se propaga para que la pagina muestre el rechazo al lado del formulario.
      return Promise.reject(new Error(mensaje))
    })
}


/**
 * Cambia la cantidad o el precio de un item de una compra que todavia no se
 * finaliza. Se guarda el valor nuevo, no se suma al anterior como hace
 * guardar-item: aqui la idea es corregir la fila, no agregar mercaderia.
 */
const updatePurchaseItem = (endpoint, form) => {
  const request = api.post(`/compra-detalle/${endpoint}`, form)
  return (dispatch) => {
    dispatch({ type: CRUD_PURCHASE_ITEM, payload: { loading: true } })
    return request
      .then((response) => {
        if (response.data.status === 200) {
          dispatch({ type: CRUD_PURCHASE_ITEM, payload: { loading: false, crud: true } })
          toast.success(response.data.message)
          return response.data
        }
        dispatch({ type: CRUD_PURCHASE_ITEM, payload: { loading: false, crud: false } })
        toast.error(response.data.message)
        return Promise.reject(new Error(response.data.message))
      })
      .catch((error) => {
        dispatch({ type: CRUD_PURCHASE_ITEM, payload: { loading: false, crud: false } })
        toast.error(error?.response?.data?.message || 'No se pudo actualizar el item')
        return Promise.reject(error)
      })
  }
}

export function updatePurchaseItemQuantity(form) {
  return updatePurchaseItem('actualizar-cantidad', form)
}

export function updatePurchaseItemPrice(form) {
  return updatePurchaseItem('actualizar-precio', form)
}

export function updatePurchaseItemSubtotal(form) {
  return updatePurchaseItem('actualizar-subtotal', form)
}

export function updatePurchaseItemBono(form) {
  return updatePurchaseItem('actualizar-bono', form)
}

export function savePurchaseHeader(form) {
  const request = api.post(
    `/compra/guardar-cabecera`,
    form
  )
  /*
   * Devuelve la promesa y REECHAZA cuando el backend no acepto el cambio.
   *
   * Antes solo mostraba el toast y resolvia igual: el modal que llama a esta
   * accion cerraba siempre, aunque la compra no se hubiera guardado. Quien llama
   * necesita saber si pudo cerrar o debe dejar el formulario abierto para que el
   * operador lea el motivo.
   */
  return (dispatch) => {
    dispatch({ type: CRUD_PURCHASE_HEADER, payload: { loading: true } })

    return request
      .then((response) => {
        setTimeout(() => {
          dispatch({
            type: CRUD_PURCHASE_HEADER,
            payload: { loading: false, crud: false, data: null },
          })
        }, 50)

        if (response.data.status === 200) {
          dispatch({
            type: CRUD_PURCHASE_HEADER,
            payload: {
              loading: false,
              crud: true,
              data: response.data.detalles,
            },
          })
          toast.success(response.data.message)

          return response.data
        }

        toast.error(response.data.message)

        // Se marca para que el catch no repita el toast: el mensaje del backend
        // ya se mostro.
        const error = new Error(response.data.message)
        error.mensajeYaMostrado = true

        return Promise.reject(error)
      })
      .catch((error) => {
        dispatch({
          type: CRUD_PURCHASE_HEADER,
          payload: { loading: false, crud: false, data: null },
        })

        // Si el backend ya habia mostrado el mensaje (status distinto de 200),
        // no se repite el toast: aqui solo se avisa del fallo de red o similar.
        if (error?.mensajeYaMostrado) {
          return Promise.reject(error)
        }

        toast.error('Error inesperado. No se pudo generar la compra')
        console.log(error)

        return Promise.reject(error)
      })
  }
}

export function savePurchaseItem(form) {
  const request = api.post(
    `/compra-detalle/guardar-item`,
    form
  )
  return (dispatch) => {
    dispatch({ type: CRUD_PURCHASE_ITEM, payload: { loading: true } })
    request
      .then((response) => {
        if (parseInt(response.data.status) === 200) {
          dispatch({
            type: CRUD_PURCHASE_ITEM,
            payload: { loading: false, crud: true },
          })
          toast.success(response.data.message)
        } else {
          toast.error(response.data.message)
        }
        setTimeout(() => {
          dispatch({
            type: CRUD_PURCHASE_ITEM,
            payload: { loading: false, crud: false },
          })
        }, 50)
      })
      .catch((error) => {
        dispatch({
          type: CRUD_PURCHASE_ITEM,
          payload: { loading: false, crud: false },
        })
        toast.error('Error inesperado. No se pudo guardar el item')
        console.log(error)
      })
  }
}

export function getPurchaseItems({ purchaseId = 0 }) {
  const request = api.get(
    `/compra-detalle/items?idcompra=${purchaseId}`
  )
  return (dispatch) => {
    dispatch({ type: GET_PURCHASE_ITEMS, payload: { loading: true } })
    request
      .then((response) => {
        dispatch({
          type: GET_PURCHASE_ITEMS,
          payload: { loading: false, data: response.data.detalles },
        })

        setTimeout(() => {
          dispatch({
            type: GET_PURCHASE_ITEMS,
            payload: { loading: false, data: null },
          })
        }, 50)
      })
      .catch((error) => {
        dispatch({
          type: GET_PURCHASE_ITEMS,
          payload: { loading: false, data: null },
        })
        toast.error(
          'Error inesperado. No se pudo obtener los items de la compra'
        )
        console.log(error)
      })
  }
}

export function deletePurchaseItem(form) {
  const request = api.post(
    `/compra-detalle/eliminar-item`,
    form
  )
  return (dispatch) => {
    dispatch({ type: CRUD_PURCHASE_ITEM, payload: { loading: true } })
    request
      .then((response) => {
        if (parseInt(response.data.status) === 200) {
          dispatch({
            type: CRUD_PURCHASE_ITEM,
            payload: { loading: false, crud: true },
          })
          toast.success(response.data.message)
        } else {
          toast.error(response.data.message)
        }
        setTimeout(() => {
          dispatch({
            type: CRUD_PURCHASE_ITEM,
            payload: { loading: false, crud: false },
          })
        }, 50)
      })
      .catch((error) => {
        dispatch({
          type: CRUD_PURCHASE_ITEM,
          payload: { loading: false, crud: false },
        })
        toast.error('Error inesperado. No se pudo eliminar el item')
        console.log(error)
      })
  }
}

export function finishPurchaseDetail(form) {
  const request = api.post(
    `/compra-detalle/finalizar-items`,
    form
  )
  return (dispatch) => {
    dispatch({ type: FINISH_PURCHASE_DETAIL, payload: { loading: true } })
    request
      .then((response) => {
        if (parseInt(response.data.status) === 200) {
          dispatch({
            type: FINISH_PURCHASE_DETAIL,
            payload: { loading: false, crud: true },
          })
          toast.success(response.data.message)
        } else {
          toast.error(response.data.message)
        }
        setTimeout(() => {
          dispatch({
            type: FINISH_PURCHASE_DETAIL,
            payload: { loading: false, crud: false },
          })
        }, 50)
      })
      .catch((error) => {
        dispatch({
          type: FINISH_PURCHASE_DETAIL,
          payload: { loading: false, crud: false },
        })
        toast.error(
          'Error inesperado. No se pudo finalizar el detalle de la compra'
        )
        console.log(error)
      })
  }
}

export function deletePurchase(form) {
  const request = api.post(
    `/compra/eliminar-compra`,
    form
  )
  return (dispatch) => {
    dispatch({ type: CRUD_PURCHASE, payload: { loading: true } })
    toast.info('Anulando compra...', {
      toastId: 'deleteOutput',
      autoClose: false,
    })
    request
      .then((response) => {
        if (parseInt(response.data.status) === 200) {
          dispatch({
            type: CRUD_PURCHASE,
            payload: { loading: false, crud: true },
          })
          toast.success(response.data.message, {
            toastId: 'deleteOutput',
            autoClose: 5000,
          })
        } else {
          toast.error(response.data.message, {
            toastId: 'deleteOutput',
            autoClose: 5000,
          })
        }
        setTimeout(() => {
          dispatch({
            type: CRUD_PURCHASE,
            payload: { loading: false, crud: false },
          })
        }, 50)
      })
      .catch((error) => {
        dispatch({
          type: CRUD_PURCHASE,
          payload: { loading: false, crud: false },
        })
        toast.error('Error inesperado, no se pudo anular la compra', {
          toastId: 'deleteOutput',
        })
        console.log(error)
      })
  }
}

export function finishPurchase(form) {
  const request = api.post(
    `/compra/finalizar-compra`,
    form
  )
  return (dispatch) => {
    dispatch({ type: CRUD_PURCHASE, payload: { loading: true } })
    toast.info('Finalizando compra...', {
      toastId: 'finishPurchase',
      autoClose: false,
    })
    request
      .then((response) => {
        if (parseInt(response.data.status) === 200) {
          dispatch({
            type: CRUD_PURCHASE,
            payload: { loading: false, crud: true },
          })
          toast.success(response.data.message, {
            toastId: 'finishPurchase',
            autoClose: 5000,
          })
        } else {
          toast.error(response.data.message, {
            toastId: 'finishPurchase',
            autoClose: 5000,
          })
        }
        setTimeout(() => {
          dispatch({
            type: CRUD_PURCHASE,
            payload: { loading: false, crud: false },
          })
        }, 50)
      })
      .catch((error) => {
        dispatch({
          type: CRUD_PURCHASE,
          payload: { loading: false, crud: false },
        })
        toast.error('Error inesperado, no se pudo finalizar la compra', {
          toastId: 'finishPurchase',
        })
        console.log(error)
      })
  }
}

export function enablePurchaseEdition(form) {
  const request = api.post(
    `/compra/habilitar-edicion`,
    form
  )
  return (dispatch) => {
    dispatch({ type: CRUD_PURCHASE, payload: { loading: true } })
    toast.info('Habilitando edición de compra...', {
      toastId: 'enablePurchase',
      autoClose: false,
    })
    request
      .then((response) => {
        if (parseInt(response.data.status) === 200) {
          dispatch({
            type: CRUD_PURCHASE,
            payload: { loading: false, crud: true },
          })
          toast.success(response.data.message, {
            toastId: 'enablePurchase',
            autoClose: 5000,
          })
        } else {
          toast.error(response.data.message, {
            toastId: 'enablePurchase',
            autoClose: 5000,
          })
        }
        setTimeout(() => {
          dispatch({
            type: CRUD_PURCHASE,
            payload: { loading: false, crud: false },
          })
        }, 50)
      })
      .catch((error) => {
        dispatch({
          type: CRUD_PURCHASE,
          payload: { loading: false, crud: false },
        })
        toast.error('Error inesperado, no se pudo habilitar la edición de la compra', {
          toastId: 'enablePurchase',
        })
        console.log(error)
      })
  }
}

/**
 * Limpia el aviso de rechazo de la ultima correccion.
 *
 * Se dispara al salir de la pagina de accion para que el mensaje no aparezca
 * en la siguiente operacion.
 */
export function clearCorrectionError() {
  return {
    type: CRUD_PURCHASE_ITEM_CORRECTION,
    payload: { loading: false, error: null },
  }
}

/**
 * Corrige el PROVEEDOR de una compra finalizada.
 *
 * Envia solo el id de la compra y el nuevo proveedor. El resto de la cabecera no
 * se manda: cambiar el proveedor no obliga a reenviar la compra entera.
 */
export function saveCorrectionProvider({ compra_id, persona_id }) {
  return (dispatch) => {
    dispatch({ type: CRUD_PURCHASE_PROVIDER, payload: { loading: true, error: null } })

    return api
      .post('/compra/correccion/proveedor', { compra_id, persona_id })
      .then(
        (response) => {
          // Ver saveCorrectionField: el codigo real viene en `data.status`.
          if (Number(response.data.status) !== 200) {
            throw correctionFailure(response.data.message, true)
          }

          return response.data
        },
        (error) => {
          throw correctionFailure(error?.response?.data?.message, false)
        }
      )
      .catch((fallo) => {
        const mensaje = fallo.mensaje || 'No se pudo cambiar el proveedor'

        dispatch({
          type: CRUD_PURCHASE_PROVIDER,
          payload: { loading: false, error: mensaje },
        })

        // El proveedor va en un boton suelto, sin modal alrededor, asi que su
        // rechazo necesita salir como aviso para que se vea.
        toast.error(mensaje)

        return Promise.reject(new Error(mensaje))
      })
      .then((data) => {
        dispatch({ type: CRUD_PURCHASE_PROVIDER, payload: { loading: false } })

        toast.success(data.message || 'Proveedor actualizado')

        return data
      })
  }
}

/**
 * Corrige UN campo suelto de la cabecera de una compra finalizada.
 *
 * Se manda solo `compra_id`, el nombre del campo y su valor. Nunca la compra
 * entera: cada campo tiene sus propias consecuencias (credito, kardex, totales)
 * y el backend las resuelve segun el campo que es.
 *
 * @param {string} campo  fecha | numero_comprobante | serie_guia | flete |
 *                        tipo_igv | tipocambio | tipo_moneda_id
 */
export function saveCorrectionField({
  compra_id,
  campo,
  valor,
  // `tipo_pago_id` no viaja solo: la forma de pago va pegada a el porque cada
  // forma pertenece a un tipo, y si esa forma pide dias a mano van los dias.
  tipo_forma_pago_id,
  tipo_forma_pago_valor,
  // El flete no viaja en `valor`: se corrigen sus dos entradas y el backend
  // deriva el total. Sin esto el action se los comia y llegaba "no es un número".
  imp_flete,
  cant_flete,
}) {
  return (dispatch) => {
    dispatch({
      type: CRUD_PURCHASE_FIELD,
      payload: { loading: true, campo, error: null },
    })

    return api
      .post('/compra/correccion/campo', {
        compra_id,
        campo,
        valor,
        tipo_forma_pago_id,
        tipo_forma_pago_valor,
        imp_flete,
        cant_flete,
      })
      .then(
        (response) => {
          // Este proyecto responde siempre con HTTP 200 y manda el codigo real en
          // `status`. Sin esta comprobacion un rechazo caia en la rama de
          // exito y se anunciaba con el toast verde de "todo bien".
          if (Number(response.data.status) !== 200) {
            throw correctionFailure(response.data.message, true)
          }

          return response.data
        },
        // Falla de red o 4xx/5xx de verdad: el mensaje puede venir en la respuesta.
        (error) => {
          throw correctionFailure(error?.response?.data?.message, false)
        }
      )
      .catch((fallo) => {
        const mensaje = fallo.mensaje || 'No se pudo corregir el campo'

        dispatch({
          type: CRUD_PURCHASE_FIELD,
          payload: { loading: false, campo, error: mensaje },
        })

        // El rechazo previsto (Kardex desfasado, no hay crédito disponible, valor
        // repetido...) se dibuja en rojo dentro del modal, junto al campo, que es
        // donde el operador tiene la mirada. Solo los errores inesperados saltan
        // como aviso, que si no seria ruido.
        if (!fallo.delBackend) {
          toast.error(mensaje)
        }

        return Promise.reject(new Error(mensaje))
      })
      .then((data) => {
        dispatch({
          type: CRUD_PURCHASE_FIELD,
          payload: { loading: false, campo },
        })

        toast.success(data.message || 'Campo actualizado')

        return data
      })
  }
}

/**
 * Corrige UNA linea de item: producto, precio o cantidad.
 *
 * Es su propio action y no una extension de `saveCorrectionField` porque el
 * error tambien se guarda aparte: si se compartieran, el rechazo de un item
 * apareceria debajo del modal de la cabecera y el operador no sabria de donde
 * salio.
 */
export function saveCorrectionItem({
  compra_id,
  detalle_id,
  campo,
  valor,
}) {
  return (dispatch) => {
    dispatch({
      type: CRUD_PURCHASE_ITEM_FIELD,
      payload: { loading: true, detalle_id, error: null },
    })

    return api
      .post('/compra/correccion/item', { compra_id, detalle_id, campo, valor })
      .then(
        (response) => {
          // Mismo criterio que el resto del modulo: el codigo real viene en
          // `status`, no en el codigo HTTP.
          if (Number(response.data.status) !== 200) {
            throw correctionFailure(response.data.message, true)
          }

          return response.data
        },
        (error) => {
          throw correctionFailure(error?.response?.data?.message, false)
        }
      )
      .catch((fallo) => {
        dispatch({
          type: CRUD_PURCHASE_ITEM_FIELD,
          payload: {
            loading: false,
            detalle_id,
            error: fallo.mensaje || 'No se pudo corregir el item',
          },
        })

        return Promise.reject(new Error(fallo.mensaje))
      })
      .then((data) => {
        dispatch({
          type: CRUD_PURCHASE_ITEM_FIELD,
          payload: { loading: false, detalle_id },
        })

        return data
      })
  }
}
